import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import Auth from "../pages/auth";
import MySales from "../pages/whrManager/sales/mysales/mysales";
import DepartmentSales from "../pages/whrManager/sales/from-department/departmentSales";
import Shipments from "../pages/whrManager/sales/shipments";
import FinishedSales from "../pages/whrManager/sales/finishedSales";
import Sales from "../pages/salesManager/sales/sales";
import ShipmentItems from "../pages/salesManager/shipments";
import FinishedSalesManager from "../pages/salesManager/finishedSales";
import ClientsSales from "../pages/salesManager/clients/clients";
import Debtors from "../pages/salesManager/debtors";
import Reports from "../pages/whrManager/reports";
import AcceptedProducts from "../pages/whrManager/stockTrasnfers/accepted";
import CanceledTranferRequests from "../pages/whrManager/stockTrasnfers/CanceledTransfers";
import InTransitTransfers from "../pages/whrManager/stockTrasnfers/InTransit";
import InventoryTransferRequests from "../pages/whrManager/stockTrasnfers/InventoryTrasferRequest";
import ConfirmedTransfers from "../pages/whrManager/stockTrasnfers/ConfirmedTransfers";
import Purchasement from "../pages/whrManager/purchasement/purchasement";
import Dashboard from "../pages/dashboard";
import ReportsSales from "../pages/salesManager/reports";
import Tracking from "../pages/tracking";
import ShippedReports from "../pages/shippedReports";
import ReturnedItems from "../pages/returnedItems";
import AcceptPaymentCustomer from "../pages/salesManager/incoming-payment/accept-payment-customer";
import AcceptPaymentDelivery from "../pages/salesManager/incoming-payment/accept-payment-delivery";
import AcceptPaymentAccount from "../pages/salesManager/incoming-payment/accept-payment-account";
import SupplierPayment from "../pages/salesManager/outgoing-payments/supplier-payment";
import ActSverki from "../pages/salesManager/akt-sverki/act-sverki";
import ConversionPage from "../pages/salesManager/conversion";
import CreatePaymentPage from "../pages/salesManager/outgoing-payments/create-payment";
import IncomingPayments from "../pages/whrManager/cash/incoming-payments";
import OutgoingPayments from "../pages/whrManager/cash/outgoing-payments";
import ActSverka from "../pages/whrManager/cash/act-sverka";
import PurchaseDelivery from "../pages/whrManager/purchaseDelivery/purchasement";
import DriverReports from "../pages/whrManager/driverReports";
import EmployeeReports from "../pages/whrManager/employeeReports";
import DashboardAccountant from "../pages/accountant/dashboardAccountant";
import LoadedPayments from "../pages/accountant/loadedPayments";
import ActSverkaAccountant from "../pages/accountant/actSverkaAccountant";
import Recommendation from "../pages/accountant/recommendations";
import BankStatements from "../pages/accountant/bankStatements";
import ConversionAccountant from "../pages/accountant/conversionAccountant";
import OrderPage from "../pages/whrManager/orderPage";
import MaterialReports from "../pages/whrManager/materialReports";
import MaterialReportKg from "../pages/whrManager/materialReportKg";
import AvailabilityReport from "../pages/whrManager/availabilityReports";
import ReturnRequest from "../pages/whrManager/returns/ReturnRequest";
import ReturnsList from "../pages/whrManager/returns/ReturnsList";

const ReturnUnconfirmed = () => (
  <ReturnRequest defaultReturnStatus="Tasdiqlanmagan" defaultCancelled="N" />
);
const ReturnConfirmed = () => (
  <ReturnRequest defaultReturnStatus="Tasdiqlangan" defaultCancelled="N" />
);
const ReturnCanceled = () => <ReturnRequest defaultCancelled="Y" />;


const ProtectedRoute = ({ element: Component, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.main.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return <Component {...rest} />;
};

const RoutesComponent = () => {
  const isAuthenticated = useSelector((state) => state.main.isAuthenticated);
  const role = useSelector((state) => state.main.role);
  const MyShipmentItems = role === "Seller" ? ShipmentItems : Shipments;
  const MyFinishedSalesManager =
    role === "Seller" ? FinishedSalesManager : FinishedSales;
  const MyReports = role === "Seller" ? ReportsSales : Reports;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate to={isAuthenticated ? "/dashboard" : "/auth"} replace />
        }
      />
      <Route path="/auth" element={<Auth />} />

      {/* Accountant Routes */}
      <Route
        path="/dashboard-accountant"
        element={<ProtectedRoute element={DashboardAccountant} />}
      />
      <Route
        path="/loaded-payments"
        element={<ProtectedRoute element={LoadedPayments} />}
      />
      <Route
        path="/loaded-payments/:id"
        element={<ProtectedRoute element={LoadedPayments} />}
      />
      <Route
        path="/act-sverka-accountant"
        element={<ProtectedRoute element={ActSverkaAccountant} />}
      />
      <Route
        path="/act-sverka-accountant/:id"
        element={<ProtectedRoute element={ActSverkaAccountant} />}
      />
      <Route
        path="/bank-statement/:id"
        element={<ProtectedRoute element={BankStatements} />}
      />
      <Route
        path="/conversion-accountant/:id"
        element={<ProtectedRoute element={ConversionAccountant} />}
      />
      <Route
        path="/recommendation"
        element={<ProtectedRoute element={Recommendation} />}
      />

      {/* Warehouse Manager Routes */}
      <Route
        path="/orderPage"
        element={<ProtectedRoute element={OrderPage} />}
      />
      <Route
        path="/incoming-payments-wrh"
        element={<ProtectedRoute element={IncomingPayments} />}
      />
      <Route
        path="/outgoing-payments-wrh"
        element={<ProtectedRoute element={OutgoingPayments} />}
      />
      <Route
        path="/act-sverka-wrh"
        element={<ProtectedRoute element={ActSverka} />}
      />
      <Route
        path="/purchase-delivery"
        element={<ProtectedRoute element={PurchaseDelivery} />}
      />
      <Route
        path="/driver-reports"
        element={<ProtectedRoute element={DriverReports} />}
      />
      <Route
        path="/employee-reports"
        element={<ProtectedRoute element={EmployeeReports} />}
      />
      <Route
        path="/returned-items"
        element={<ProtectedRoute element={ReturnedItems} />}
      />
      <Route
        path="/return-unconfirmed"
        element={<ProtectedRoute element={ReturnUnconfirmed} />}
      />
      <Route
        path="/return-confirmed"
        element={<ProtectedRoute element={ReturnConfirmed} />}
      />
      <Route
        path="/return-canceled"
        element={<ProtectedRoute element={ReturnCanceled} />}
      />
      <Route
        path="/returns-list"
        element={<ProtectedRoute element={ReturnsList} />}
      />

      {/* Common Routes */}
      <Route path="/reports" element={<ProtectedRoute element={MyReports} />} />
      <Route
        path="/dashboard"
        element={<ProtectedRoute element={Dashboard} />}
      />
      <Route path="/tracking" element={<ProtectedRoute element={Tracking} />} />
      <Route
        path="/shippedReports"
        element={<ProtectedRoute element={ShippedReports} />}
      />
      <Route path="/debtors" element={<ProtectedRoute element={Debtors} />} />
      <Route
        path="/clients"
        element={<ProtectedRoute element={ClientsSales} />}
      />

      {/* Cashier Routes */}
      <Route
        path="/accepting-payment-from-customer"
        element={<ProtectedRoute element={AcceptPaymentCustomer} />}
      />
      <Route
        path="/accepting-payment-from-delivery"
        element={<ProtectedRoute element={AcceptPaymentDelivery} />}
      />
      <Route
        path="/accepting-payment-from-account"
        element={<ProtectedRoute element={AcceptPaymentAccount} />}
      />
      <Route
        path="/outgoing-payment-supplier"
        element={<ProtectedRoute element={SupplierPayment} />}
      />
      <Route
        path="/create-payment"
        element={<ProtectedRoute element={CreatePaymentPage} />}
      />
      <Route
        path="/act-sverki"
        element={<ProtectedRoute element={ActSverki} />}
      />
      <Route
        path="/conversion"
        element={<ProtectedRoute element={ConversionPage} />}
      />

      {/* Non-Seller Routes */}
      {role !== "Seller" && (
        <>
          <Route
            path="/from-department"
            element={<ProtectedRoute element={DepartmentSales} />}
          />
          <Route
            path="/purchasement"
            element={<ProtectedRoute element={Purchasement} />}
          />
          <Route
            path="/accepted"
            element={<ProtectedRoute element={AcceptedProducts} />}
          />
          <Route
            path="/canceledTransferRequests"
            element={<ProtectedRoute element={CanceledTranferRequests} />}
          />
          <Route
            path="/inTransitTransfers"
            element={<ProtectedRoute element={InTransitTransfers} />}
          />
          <Route
            path="/confirmedTransfers"
            element={<ProtectedRoute element={ConfirmedTransfers} />}
          />
          <Route
            path="/inventoryTransferRequests"
            element={<ProtectedRoute element={InventoryTransferRequests} />}
          />
          <Route
            path="/materialReports"
            element={<ProtectedRoute element={MaterialReports} />}
          />
          <Route
            path="/materialReportKg"
            element={<ProtectedRoute element={MaterialReportKg} />}
          />
          <Route
            path="/availabilityReport"
            element={<ProtectedRoute element={AvailabilityReport} />}
          />
        </>
      )}

      {/* Sales Routes */}
      <Route
        path="/shipments"
        element={<ProtectedRoute element={MyShipmentItems} />}
      />
      <Route
        path="/closing-sale"
        element={<ProtectedRoute element={MyFinishedSalesManager} />}
      />
      {/* Catch all undefined routes */}
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default RoutesComponent;
